<template>
  <div>
    <div class="search flex">
      <span class="tit">预约管理</span>
      <div class="flex">
        <el-button @click="toEvent" size="mini" class="addBtn">操作日志</el-button>
        <el-date-picker style="border: 1px solid #567CFF;height: 36px; border-radius: 0;margin-left: 8px"
            v-model="search.appointDateRange"
            type="daterange"
                        @change="changeCondition"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-input placeholder="预约号/医生姓名" class="addART" v-model="search.keyword"
                  suffix-icon="el-icon-search"
                  size="small"
                  @change="changeCondition"></el-input>
      </div>
    </div>
    <div>

      <el-radio-group
          v-model="search.appointState"
          size="small" class="radioGroup"
          @change="changeCondition">
        <el-radio-button :label="0">所有</el-radio-button>
        <el-radio-button :label="1">待通话</el-radio-button>
        <el-radio-button :label="3">待分析</el-radio-button>
        <el-radio-button :label="4">已完成</el-radio-button>
      </el-radio-group>

    </div>
    <div class="instrument">
      <el-table :data="data" class="record-table" style="margin-bottom: 20px"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="100vh"
                max-height="calc(100vh - 340px)">
        <el-table-column prop="appointNo" label="预约编号" width="160" align="center"></el-table-column>
        <el-table-column prop="doctorName" align="center" label="预约医生"></el-table-column>
        <el-table-column prop="appointDateShow" label="预约时间" align="center" > </el-table-column>
        <el-table-column prop="appointState" align="center" label="预约状态">
          <template slot-scope="props">
                        <span>
                            {{
                            props.row.appointState === 0 ? '已提交'
                            : props.row.appointState === 1 ? '待通话'
                            : props.row.appointState === 2 ? '已失效'
                            : props.row.appointState === 3 ? '待分析'
                            : props.row.appointState === 4 ? '已完成'
                            : props.row.appointState === 5 ? '已取消'
                            : ''
                          }}
                        </span>
          </template>
        </el-table-column>
        <el-table-column prop="payAmount" align="center" label="支付金额"></el-table-column>

        <el-table-column align="center" width="160" label="操作" class-name="operate-column">
          <template slot-scope="props">
            <el-button size="mini" @click="cancel(props.row.id)" type="text" class="btn" v-if="props.row.appointState===1">取消</el-button>
            <el-button size="mini" @click="showRemind(props.row)" type="text" class="btn">提醒</el-button>
            <el-button size="mini" @click="toDetail(props.row.id)" type="text" class="btn">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :hide-on-single-page="true"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
    <!--修改预约-->
    <el-dialog title="修改预约时间" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form>
        <el-form-item>
          <span>预约编号:{{ updateDate.appointNo }}</span>
        </el-form-item>
        <el-form-item>
          <div class="block">
            <el-date-picker
                v-model="updateDate.appointDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-input-number v-model="updateDate.appointTimeSlot" placeholder="请输入时间点(0-23)" :min="0"
                           :max="23"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-input v-model="updateDate.reason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateDateOk">确 定</el-button>
            </span>
    </el-dialog>
    <!--提醒-->
    <el-drawer title="提醒" :wrapperClosable="false" :close-on-press-escape="false"
               :show-close="false" size="600px" class="drawerCommon" :visible.sync="remindVisible"
    >
      <el-form label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="选择提醒人">
          <el-radio-group v-model="remindData.target">
            <el-radio :label="0">用户</el-radio>
            <el-radio :label="1">医生</el-radio>
            <el-radio :label="2">全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="remindData.reason" type="textarea" :rows="5" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="remind" type="primary" size="small">确 定</el-button>
        <el-button @click="remindVisible = false" size="small">取 消</el-button>

      </div>
    </el-drawer>
  </div>
</template>

<script>
import common from "../../../api/common";
import qs from "qs";

export default {
  name: "appointList",
  data() {
    return {
      page: {
        current: 1,
        size: 10,
        total: 8,
      },//分页
      search:{
        keyword: '',
        appointState: 0,
        appointDateRange:[],
      },

      data: [],
      dialogVisible: false,
      updateDate: {
        id: '',
        appointNo: '',
        appointDate: '',
        appointTimeSlot: '',
        reason: ''
      },
      cancelUpdateData: {
        eventId: '',//预约id
        reason: '',//原因
      },

      remindVisible: false,
      remindData: {
        id: '',
        reason: '',
        target: 2,
      },
    }
  },
  mounted() {
    //1. 默认时间段为当前时间前后15天内数据
    let todayBeginMs = new Date().setHours(0,0,0,0);
    let subMs = 1296000000; //15天间隔的ms值
    //this.search.appointStartLongtime = todayBeginMs - subMs;
    //this.search.appointEndLongtime = todayBeginMs + subMs;

    this.search.appointDateRange.push(todayBeginMs - subMs, todayBeginMs + subMs)

    console.log(this.search);

    // appointStartLongtime
    // appointEndLongtime

    //2. 加载数据
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let data = {
        appointState: that.search.appointState,
        keyword: that.search.keyword
      };
      if(that.search.appointDateRange.length==2){
        data.appointStartLongtime = new Date(that.search.appointDateRange[0]).getTime();
        data.appointEndLongtime = new Date(that.search.appointDateRange[1]).getTime();
      }
      this.$ajax
          .post(common.basePath + 'medical/medical-appoint/admin/page/condition/' +  that.page.current + "/" + that.page.size, data)
          .then(function (res) {
            if (res.data.status === 'success') {
              if(res.data.rows.length !=0 ){
                // 处理显示时间
                $(res.data.rows).each((i,o)=>{
                  o.appointDateShow = '-';
                  if(o.appointStartLongtime && o.appointEndLongtime){
                    let s = new Date(o.appointStartLongtime);
                    let e = new Date(o.appointEndLongtime);
                    if(s.Format('yyyyMMdd') === e.Format('yyyyMMdd')){ //同一天
                      o.appointDateShow = s.Format('yyyy-MM-dd HH:mm') +' ~ '+ e.Format('HH:mm');
                    }else{
                      o.appointDateShow = s.Format('yyyy-MM-dd HH:mm') +' ~ '+ e.Format('yyyy-MM-dd HH:mm');
                    }
                  }
                })
              }
              that.data = res.data.rows;
              that.page.total = res.data.total;
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
            console.error(err);
            that.$message.error("信息加载失败");
      })
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    changeCondition() {
      this.page.current = 1;
      this.getData();
    },
    showRemind(item) {
      this.remindData.id = item.id;
      this.remindVisible = true;
    },
    remind() {
      let that = this;
      this.$ajax.get(common.api.appoint.admin.remind, {
        params: {
          id: this.remindData.id,
          reason: this.remindData.reason,
          target: this.remindData.target
        }
      }).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("操作成功");
          that.getData()
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      });
    },
    update(id, no) {
      this.dialogVisible = true;
      this.updateDate.id = id;
      this.updateDate.appointNo = no;
      this.updateDate.reason = '';
    },
    updateDateOk() {
      let that = this;
      this.dialogVisible = false;
      this.$ajax.get(common.api.appoint.admin.update, {
        params: {
          id: this.updateDate.id,
          appointDate: this.updateDate.appointDate,
          appointTimeSlot: this.updateDate.appointTimeSlot,
          reason: this.updateDate.reason
        }
      }).then(function (res) {
        if (res.data.status === 'success') {
          that.$message.success("操作成功");
          that.getData()
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      })
    },
    cancel(id) {
      let that = this;
      this.$prompt('请输入原因(原因将会发往用户和医生)', '取消预约', {
        confirmButtonText: '提交',
        cancelButtonText: '关闭',
      }).then(({value}) => {
        let data = {
          reason: value,
        }
        this.$ajax.post(common.basePath + 'medical/medical-appoint/admin/cancel/' + id, qs.stringify(data)).then(function (res) {
          if (res.data.status === 'success') {
            that.$message.success("操作成功")
            that.getData()
          } else {
            that.$message.error(res.data.message)
          }
        }).catch((err) => {
          console.error(err)
          that.$message.error("操作失败");
        })
      })
    },
    toDetail(id) {
      this.$router.push({path: 'detail/' + id})
    },
    toEvent() {
      this.$router.push({path: '../event/list', query: {type: 'event_appoint'}})
    },
  },
  components: {
    // 'appointDetail': () => import('./appointDetail'),
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.search .radioGroup {
  margin-bottom: 0;
  margin-right: 0;
}

.radioGroup {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.operate-column{
  button.btn{
    padding: 0;
  }
}
</style>
